export const palette = [
	'#4421af',
	'#1452F5',
	'#0d88e6',
	'#00b7c7',
	'#5ad45a',
	'#8be04e',
	'#ebdc78',
];
